import CloseIcon from '@mdi/svg/svg/close.svg?react';
import TestIcon from '@mdi/svg/svg/test-tube.svg?react';
import { MDIIcon, MDIIconButton } from '@solinkcorp/solink-components';
import { Link } from 'react-router-dom';
import { env } from 'src/environment';
import useLocale from 'src/hooks/useLocale';
import FeaturesUtil from 'utils/FeaturesUtil';
import { getLocalizedJSX, getLocalizedStr } from 'utils/LocaleUtil';
import styles from './IntegrationBanner.module.sass';

export interface IntegrationBannerProps {
  setIsIntegrationBannerVisible: (isVisible: boolean) => void;
}
export default function IntegrationBanner(props: IntegrationBannerProps) {
  const locale = useLocale();
  return (
    <div className={styles.integrationBanner}>
      <div className={styles.integrationBannerText}>
        <div>
          <MDIIcon icon={TestIcon} />
        </div>
        <div>
          {getLocalizedStr({
            string: locale.integrationBanner.usingIntegrationEnv,
            replacements: {
              environmentName: env.MODE,
            },
          })}{' '}
          {FeaturesUtil.hasDeveloperAccess() &&
            getLocalizedJSX(locale.integrationBanner.switchEnvInfo, {
              useIntegrationApi: <strong key="b">{locale.preferencesPage.developerTitle}</strong>,
              preferences: (
                <Link key="a" to="/settings/preferences">
                  {locale.settingsPage.preferences}
                </Link>
              ),
            })}
        </div>
      </div>
      <MDIIconButton
        icon={CloseIcon}
        title={locale.general.close}
        onClick={() => props.setIsIntegrationBannerVisible(false)}
      />
    </div>
  );
}
